import { getFeelingArrows } from "@/utils/feeling-utils";
import { formatRelativeDate } from "@/lib/utils";
import { getFirstSentences } from "../utils";
import { TEXT_TRUNCATION } from "../constants";
import type { DailyCheckIn } from "../types";

interface RecentCheckInItemProps {
	checkIn: DailyCheckIn;
}

export function RecentCheckInItem({ checkIn }: RecentCheckInItemProps) {
	const feelingArrows = getFeelingArrows(checkIn.general_feeling);
	const description =
		checkIn.day_description && checkIn.day_description.trim()
			? getFirstSentences(
					checkIn.day_description,
					TEXT_TRUNCATION.SENTENCES_TWO,
				)
			: null;

	return (
		<div className="space-y-2 p-3 rounded-lg bg-blue-50/50 dark:bg-blue-900/10 border border-blue-200 dark:border-blue-800">
			<div className="flex items-center justify-between">
				<span className="text-sm font-semibold text-foreground">
					{formatRelativeDate(checkIn.created_at)}
				</span>
				<div className="flex items-center text-lg">{feelingArrows}</div>
			</div>
			{description && (
				<p className="text-xs text-muted-foreground leading-relaxed">
					{description}
				</p>
			)}
		</div>
	);
}
